const article = {
  id: 4,
  category: "IFRS",
  title: "IFRS 2025-2026 : Les amendements à IAS 21 et IFRS 7/9 décryptés",
  text: "Convertibilité des devises, contrats d’électricité renouvelable : ce qui change pour vos comptes consolidés. Téléchargez notre fiche synthétique.",
  link: "/articles/ifrs-2025-amendements-ias21-ifrs7",
  date: "Février 2025",
  highlight: "Des impacts directs sur votre reporting financier"
};

export default article;
